import { get } from '@core/Services/ApiService'

export const getCountryEntitlements = () =>
  get<{ data: { isCountryEntitled: boolean } }>({ url: '/api/entitlements/GetCountryEntitlements' })
